import { useVariant } from '@calendly/feature-check-react';
import { useFormContext } from '@calendly/form';
import { FieldLabel } from '@calendly/form/parts';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { useAiEventOccurred } from '@calendly/rich-text-editor';
import { Segment } from '@calendly/segment';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { RichTextField } from 'components/core/form';
import { openUserAgreementPopup } from 'features/user_agreements';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import ProTipImageSrc from './help-description.png';
const containerCss = "c1q2g6d9";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const proTipImageCss = "p1l2yvt0";
const ProTipImage = forwardRef((props, ref) => <img ref={ref} {...props} alt={I18n.t('publisher.event_types.general.description_tooltip_image')} src={ProTipImageSrc} className={classNames(proTipImageCss, props.className)} />);
const noop = () => {};
const enqueueAIAnalyticsEvent = (eventTypeId, track) => event => {
  if (event.detail?.type === 'generate_content') {
    const properties = {
      action_name: 'user_generates_ai_description',
      action_type: 'et',
      action_details: {
        id: eventTypeId
      },
      squad_ownership: 'core_ai',
      business_initiative: 'ai_text_test',
      capture_date_begin: 'April 1 2024',
      capture_date_end: 'April 30 2024'
    };
    track({
      name: TRACKING_EVENT_NAMES.USER_ACTION_CAPTURED,
      properties
    });
    Segment.track('User Action Captured', properties);
  }
};
const DescriptionLocked = ({
  hideLabel
}) => {
  const {
    values: {
      description
    }
  } = useFormContext();
  const defaultDescriptionPreview = hideLabel ? I18n.t('publisher.event_type_editor.sections.more_options.description.missing') : '';
  return <div>
      {!hideLabel && <FieldLabel text={I18n.t('publisher.event_types.general.description')} proTip={<>
              {I18n.t('publisher.event_types.general.description_tooltip')}
              <ProTipImage />
            </>} />}
      {HtmlParser(description.html || defaultDescriptionPreview)}
    </div>;
};
const DescriptionTextField = ({
  eventTypeId = null,
  hideLabel = false,
  disabled = false
}) => {
  const dispatch = useDispatch();
  const track = useTrack();
  const aiFeaturesEnabled = ['enabled_multi_buttons'].includes(useVariant('ai_text_editor'));
  const aiEventCallback = aiFeaturesEnabled ? enqueueAIAnalyticsEvent(eventTypeId, track) : noop;
  const showUserAgreement = onAgree => dispatch(openUserAgreementPopup({
    name: 'ai_beta_terms',
    onAgree
  }));
  useAiEventOccurred(aiEventCallback);
  return <Container>
      <RichTextField id="wysiwyg-description" label={I18n.t('publisher.event_types.general.description')} proTip={<>
            {I18n.t('publisher.event_types.general.description_tooltip')}
            <ProTipImage />
          </>} name="description" placeholder={I18n.t('publisher.event_types.general.description_field.placeholder')} disabled={disabled} useNarrowTooltip aiFeaturesEnabled={aiFeaturesEnabled} editorUsageType="event_type_description" eventTypeId={eventTypeId} showUserAgreement={showUserAgreement} source="et" hideLabel={hideLabel} />
    </Container>;
};
export const Description = ({
  isLocked,
  ...props
}) => !isLocked ? <DescriptionTextField {...props} /> : <DescriptionLocked {...props} />;

require("./description.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./description.js");